<template>
  <div class="add-task-container mb-4 shadow-sm">
    <div class="d-flex flex-column flex-md-row gap-2">
      <RouterLink :to="`/users/create/?is_from_reports=${isFromReports}`"
                  class="btn btn-primary" type="button">
        <i class="bi bi-plus"></i> Добавить
      </RouterLink>
    </div>
  </div>

  <div class="default-table-area style-two all-projects">
    <div class="container- py-1 px-4-" style="margin-top: -50px;">
      <div class="mb-4" style="display: none;">
        <input
            type="text"
            ref="datePicker"
            class="form-control bg-white text-dark border"
            placeholder="Выберите дату"
        />
      </div>

      <!-- Add Task -->
      <div class="add-task-container mb-4 shadow-sm">
        <div class="d-flex flex-column flex-md-row gap-2">

          <!--                  <button
                                class="btn btn-primary" type="button" @click="addTask"
                                :disabled="loading">
                              <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                              <i v-else class="bi bi-plus"></i> Добавить
                            </button>-->
        </div>
      </div>

      <!-- Tasks List -->
      <div class="card bg-white- border mb-4 shadow-sm">


        <div class="card-body p-0">

          <br/>
          <ul class="list-group list-group-flush">
            <li
                v-for="(task, index) in userList"
                :key="task.id"
                class="list-group-item bg-white text-dark border-bottom position-relative-"
                :class="{ 'active-task': task.selected }"
            >
              <div class="d-flex align-items-start justify-content-between">
                <div class="flex-grow-1">
                  <div
                      class="py-2 task-content"
                  >
                    <div class="d-flex flex-column">
                      <div class="d-flex justify-content-between- align-items-start">
                        <div class="form-check- pe-2 m-0">
                        </div>

                        <div
                            class="form-check-label mb-0"
                            :for="'task-' + task.id"
                            :class="{
                                'text-decoration-line-through text-muted': task.status === 1,
                                'text-dark': task.status !== 1
                              }"
                        >
                       <span v-if="editableTask===task.id">
  <input class="form-control" type="text" v-model="task.title">
  <div style="position:relative;left:10px" class="d-flex gap-2 mt-2">
    <button
        class="btn btn-sm btn-primary"
        @click="updateTaskTitle(task)"
    >
      Сохранить
    </button>
    <button
        class="btn btn-sm btn-outline-secondary"
        @click="editableTask=null"
    >
      Отменить
    </button>
  </div>
  <br/>
</span>
                          <span v-else>
                                  {{ task.name }}
                                </span>


                        </div>
                        <div class="d-flex">

                        </div>
                      </div>

                    </div>
                  </div>
                  <br/>
                  <!-- Comment Section - Expanded under the title -->
                  <div v-if="task.selected" class="task-comments-expanded">
                    <!--                            <div class="comment-input-section">
                                                  <h6 class="comment-section-title">Комментарий</h6>
                                                  <textarea
                                                      v-model="selectedTask.comment"
                                                      class="comment-textarea"
                                                      rows="4"
                                                      placeholder="Введите комментарий..."
                                                  ></textarea>
                                                  <button
                                                      class="btn btn-primary save-comment-btn"
                                                      @click="saveComment"
                                                      :disabled="!selectedTask.comment.trim() || loading"
                                                  >
                                                    <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                                                    <i v-else class="bi bi-save"></i> Сохранить комментарий
                                                  </button>
                                                </div>

                                                <div v-if="selectedTask.comments && selectedTask.comments.length"
                                                     class="comment-history-section">
                                                  <h6 class="comment-section-title" style="margin-top: 10px;">История комментариев</h6>
                                                  <div
                                                      class="comment-history-container scroll-container"
                                                      @touchstart="lockPageScroll"
                                                      @touchmove="lockPageScroll"
                                                  >
                                                    &lt;!&ndash;                              @wheel.prevent="handleScroll"&ndash;&gt;
                                                    <div
                                                        v-for="(comment, idx) in selectedTask.comments"
                                                        :key="idx"
                                                        class="comment-item"
                                                    >
                                                      <div class="comment-header">
                                                        <small class="comment-date">{{ formatDateTime(comment.created_at) }} </small>
                                                        <small class="comment-date"> &nbsp; &nbsp;
                                                          <i>({{ comment.user ? comment.user.name : authStore.user.name }})</i></small>
                                                      </div>
                                                      <p class="comment-text">{{ comment.comment }}</p>
                                                    </div>
                                                  </div>
                                                </div>-->
                  </div>
                </div>
                <a style="text-underline: none;" class="edit-button border-0 bg-transparent flex-shrink-0"
                   :href="`/users/edit/${task.id}?is_from_reports=${isFromReports}`">
                  <i class="material-symbols-outlined fs-16 text-body">edit</i>
                </a>

                <button class="delete-button border-0 bg-transparent flex-shrink-0"
                        v-if="userRole !== 'manager'"
                        @click="showDeleteConfirmation(task)">
                  <i class="material-symbols-outlined fs-16 text-danger" title="Удалить">delete</i>
                </button>

              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-if="deleteAlert.visible" class="custom-alert">
    <div class="alert-content">
      <p class="alert-message">Подтвердите удаление</p>
      <div class="alert-buttons">
        <button
            type="button"
            class="btn btn-danger confirm-button"
            @click="confirmDelete"
        >
          Подтвердить
        </button>
        <button
            type="button"
            class="btn btn-secondary cancel-button"
            @click="cancelDelete"
        >
          Отменить
        </button>
      </div>
    </div>
  </div>

  <!--  <form>
      <div class="row">
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Имя и фамилия</label>
            <input type="text" class="form-control h-55" v-model="authStore.user.name"/>
          </div>
        </div>
        <div class="col-lg-6 col-sm-6">

        </div>

        <div style="display:none;">
          <div class="col-lg-6 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Паспорт</label>
              <input type="text" class="form-control h-55" v-model="authStore.user.pasport"/>
            </div>
          </div>
          <div class="col-lg-6 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Песель</label>
              <input type="text" class="form-control h-55" v-model="authStore.user.pesel"/>
            </div>
          </div>

          <div class="col-lg-6 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Работает от</label>
              <input type="text" class="form-control h-55" v-model="authStore.user.created_at"/>
            </div>
          </div>
          <div class="col-lg-6 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Уволен</label>
              <input type="text" class="form-control h-55" v-model="authStore.user.retired_at"/>
            </div>
          </div>

          <div class="col-lg-6 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Телефон</label>
              <input type="text" class="form-control h-55" v-model="authStore.user.phone"/>
            </div>
          </div>
        </div>


        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Логин</label>
            <input type="text" class="form-control h-55" v-model="authStore.user.username"/>
          </div>
        </div>

        &lt;!&ndash;              <div class="col-lg-6 col-sm-6">
                        <div class="form-group mb-4">
                          <label class="label text-secondary">Студент</label>
                          <input type="text" class="form-control h-55" v-model="authStore.user.student"/>
                        </div>
                      </div>&ndash;&gt;
        <div class="col-lg-6 col-sm-6">
          <div class="form-group mb-4">
            <label class="label text-secondary">Новый пароль</label>
            <input type="text" class="form-control h-55" v-model="authStore.user.password"/>
          </div>
        </div>


        <div class="col-lg-12">
          <div class="d-flex flex-wrap gap-3">
            &lt;!&ndash;                  <button
                                  class="btn btn-danger py-2 px-4 fw-medium fs-16 text-white"
                              >
                                Отмена
                              </button>&ndash;&gt;
            <button class="btn btn-primary py-2 px-4 fw-medium fs-16">
              Сохранить
            </button>
            <RouterLink to="/users/create"
                        class="btn btn-outline-primary  px-sm-4 fs-14 fw-medium rounded-3 hover-bg">
                                      <span class="py-sm-1 d-block">
                                          <i class="ri-add-line d-none d-sm-inline-block"></i>
                                          <span>
                                           Добавить пользователя
                                          </span>
                                      </span>
            </RouterLink>
          </div>
        </div>
      </div>
    </form>-->

</template>

<script>
import {defineComponent} from "vue";
import {useAuthStore} from "@/stores/auth"; // Adjust the path if needed
import axios from "axios";
import Flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import {Russian} from "flatpickr/dist/l10n/ru.js";
import {fetchList, createTask, updateTask, deleteTask, storeTaskComment} from '@/api/task';
import UserResource from '@/api/user';

const userResource = new UserResource();
export default defineComponent({
  name: "MyProfile",
  data() {
    return {
      isFromReports: 0,
      userList: null,
      authStore: useAuthStore(),
      successMessage: "",
      errorMessage: "",
      deleteAlert: {
        visible: false,
        row: null,
      },
    };
  },
  created() {
    // Check if is_from_reports=1 exists in URL
    this.isFromReports = this.$route.query.is_from_reports === '1' ? 1 : 0;
    this.getUserList();
  },
  methods: {
    cancelDelete() {
      this.deleteAlert.visible = false;
      this.deleteAlert.row = null;
    },
    showDeleteConfirmation(row) {
      this.deleteAlert.row = row;
      this.deleteAlert.visible = true;
    },
    showRetireConfirmation(row) {
      this.retireAlert.row = row;
      this.retireAlert.visible = true;
    },
    confirmDelete() {
      const row = this.deleteAlert.row;
      if (row) {
        userResource.destroy(row.id).then(() => {
          // const index = this.list.indexOf(row);
          //this.list.splice(index, 1);
          this.cancelDelete();
          window.location.reload()
        });
      }
    },
    async getUserList() {
      console.log('list u');
      this.loading = true;
      const {data, meta} = await userResource.list();
      this.userList = data;
      this.total = meta.total;
      this.loading = false;
    },
    async updateProfile() {
      try {
        const response = await axios.post("/api/update-profile", {
          name: this.authStore.name,
          email: this.authStore.email,
        });

        this.successMessage = response.data.message || "Profile updated successfully!";
        this.errorMessage = "";
      } catch (error) {
        this.errorMessage = error.response?.data?.message || "An error occurred.";
        this.successMessage = "";
      }
    },
  },
});
</script>

<style scoped>
.form-control {
  width: 95% !important;
  position: relative;
  left: 10px;
}

.container {
  max-width: 600px;
  background-color: #f8f9fa;
}

.active-task {
  background-color: rgba(13, 110, 253, 0.1) !important;
  border-left: 4px solid #0d6efd !important;
}

.task-content {
  cursor: pointer;
  flex-grow: 1;
}

.task-comments-section {
  border-top: 1px solid #eee;
  padding-top: 12px;
}

.comment-tree {
  max-height: 300px;
  overflow-y: auto;
}

.comment-tree::-webkit-scrollbar {
  width: 8px;
}

.comment-tree::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.comment-tree::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.comment-tree::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.form-check-input {
  border: 1px solid #ced4da;
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-control:focus, .form-select:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.btn:disabled {
  opacity: 0.65;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
}

.add-task-container .form-select {
  min-width: 120px;
}

.badge {
  font-size: 0.75rem;
  font-weight: normal;
  white-space: nowrap;
}

.text-decoration-line-through {
  text-decoration: line-through;
}

.list-group-item {
  display: flex;
  align-items: flex-start;
}

@media (max-width: 767.98px) {
  .add-task-container .d-flex {
    flex-direction: column;
  }

  .add-task-container .form-select,
  .add-task-container .btn {
    width: 100%;
    margin-top: 8px;
  }

  .list-group-item {
    flex-direction: column;
  }

  .task-content {
    width: 100%;
    margin-bottom: 8px;
  }

  .d-flex.align-items-center.flex-wrap.gap-2 {
    margin-top: 4px;
  }
}

.horizontal-calendar-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
}

.horizontal-calendar {
  display: flex;
  gap: 8px;
  min-width: min-content;
  padding: 8px 0;
}

.calendar-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 64px;
  border-radius: 8px;
  background: #f8f9fa;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.calendar-day.active {
  background: #0d6efd;
  color: white;
}

.day-name {
  font-size: 12px;
  text-transform: capitalize;
  opacity: 0.7;
}

.day-number {
  font-size: 18px;
  font-weight: 500;
}

.task-indicator {
  position: absolute;
  top: 4px;
  right: 8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #dc3545;
}

.calendar-day.active .day-name,
.calendar-day.active .day-number {
  color: white;
}

/* Hide scrollbar but keep functionality */
.horizontal-calendar-container::-webkit-scrollbar {
  display: none;
}

/* Увеличенная секция комментариев */
.task-comments-expanded {
  width: 100%;
  margin-top: 16px;
  padding: 0;
}

.comment-input-section,
.comment-history-section {
  width: 100%;
  padding: 0;
}

.comment-section-title {
  font-size: 1.1rem;
  margin-bottom: 12px;
  color: #333;
}

.comment-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
}

.save-comment-btn {
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  font-size: 1rem;
}

/* Увеличенная история комментариев */
.comment-history-container {
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 8px;
  -webkit-overflow-scrolling: touch; /* Для плавного скролла на iOS */
}

.comment-item {
  width: 100%;
  padding: 16px;
  margin-bottom: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.comment-header {
  margin-bottom: 8px;
}

.comment-date {
  font-size: 0.85rem;
  color: #6c757d;
}

.comment-text {
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Улучшения для мобильных устройств */
@media (max-width: 768px) {
  .comment-history-container {
    max-height: 50vh;
    padding-bottom: 20px; /* Чтобы не перекрывалось навигационной панелью */
  }

  .comment-textarea {
    min-height: 150px;
  }

  .comment-item {
    padding: 12px;
  }
}

/* Кастомный скроллбар */
.comment-history-container::-webkit-scrollbar {
  width: 8px;
}

.comment-history-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.comment-history-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.comment-history-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.page-wrapper {
  max-width: 100%;
  overflow-x: hidden;
  position: relative;
}

/* Общие стили для максимальной ширины */
.task-container {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
}

.task-card-wide {
  width: 100%;
  margin: 0;
  padding: 12px 4px; /* Минимальные отступы */
  border-radius: 0;
  box-shadow: none;
  border: none;
}

.task-header {
  width: 100%;
  padding: 0 4px;
  margin-bottom: 16px;
}

.task-title {
  font-size: 1.4rem;
  margin: 0;
  padding: 0;
  width: 100%;
  word-break: break-word;
}

/* Форма комментария */
.comment-form-wide {
  width: 100%;
  padding: 0 4px;
  margin-bottom: 24px;
}

.comment-title {
  margin: 0 0 8px 0;
  padding: 0;
  font-size: 1.2rem;
}

.full-width-textarea {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  padding: 12px;
  margin: 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-sizing: border-box;
  min-height: 120px;
}

.save-btn-wide {
  width: 100%;
  margin: 12px 0 0 0;
  padding: 12px;
}

/* История комментариев */
.comment-history-wide {
  width: 100%;
  padding: 0 4px;
}

.history-title {
  margin: 0 0 8px 0;
  padding: 0;
  font-size: 1.2rem;
}

.scroll-container {
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
}

.comment-item-wide {
  width: 100%;
  padding: 12px 8px;
  margin-bottom: 12px;
  background: #f8f9fa;
  border-radius: 6px;
}

.comment-meta {
  margin-bottom: 6px;
}

.comment-date {
  font-size: 0.85rem;
  color: #666;
}

.comment-text {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

/* Отключение скролла страницы при скролле комментариев */
body.scroll-locked {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

.comment-count {
  font-size: 0.85em;
  color: #6c757d;
  margin-left: 4px;
  transition: color 0.2s;
}

.unread-comments {
  color: #dc3545;
  font-weight: bold;
}

.unread-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #dc3545;
  border-radius: 50%;
  margin-left: 4px;
  vertical-align: middle;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

/* Add more spacing between task items */
.list-group-item {
  margin-bottom: 12px; /* Increase this value for more spacing */
  border-radius: 8px !important;
  border: 1px solid #dee2e6 !important;
}

/* Optional: Add more padding inside each task card */
.list-group-item > .d-flex {
  padding: 12px 8px;
}

/* If you want to increase spacing specifically for the cards */
.card.bg-white.border.mb-4.shadow-sm {
  margin-bottom: 20px !important; /* Increase this value */
}

/* If you want to add spacing between the task content and comments */
.task-comments-expanded {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

/* Edit and Delete Buttons Styles */
.edit-button, .delete-button {
  position: absolute;
  padding: 0.5rem;
  opacity: 0.7;
  transition: all 0.2s ease;
  z-index: 1;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.edit-button {
  top: 8px;
  right: 8px;
}

.delete-button {
  bottom: 8px;
  right: 8px;
}

.edit-button:hover, .delete-button:hover {
  opacity: 1;
  transform: scale(1.1);
}

.delete-button:hover {
  background-color: rgba(220, 53, 69, 0.1) !important;
}

/* Make icons larger */
.edit-button i, .delete-button i {
  font-size: 20px !important;
}

/* Mobile specific styles */
@media (max-width: 768px) {
  .edit-button, .delete-button {
    width: 40px;
    height: 40px;
    padding: 0.75rem;
  }

  .edit-button i, .delete-button i {
    font-size: 24px !important;
  }
}

/*.list-group-flush > .list-group-item {
  max-height: 150px;
}*/

</style>

<style>
.form-check-input {
  width: 1.6em !important;
  height: 1.6em !important;
  margin-top: 0.1em !important;
}

/* Adjust clickable area (optional) */
.form-check {
  min-height: 1.6em; /* Makes the label area easier to tap */
}

.form-check-label {
  font-size: 1.1rem; /* Увеличиваем размер шрифта */
  font-weight: 600; /* Делаем полужирным (можно использовать 700 для более жирного) */
  line-height: 1.4; /* Улучшаем читаемость */
  margin-bottom: 4px; /* Добавляем отступ снизу */
}

/* Для завершенных задач сохраняем перечеркивание */
.form-check-label.text-decoration-line-through {
  text-decoration: line-through;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .form-check-label {
    font-size: 1.05rem; /* Чуть меньше на мобильных */
  }
}

</style>